import classNames from 'classnames';
import { IconArrowRight2 } from '@/features/icons';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
interface Props {
  direction?: 'left' | 'right';
  onClick?: (e: React.MouseEvent) => void;
}
export default function Arrow({
  direction,
  onClick
}: Props) {
  return <span role='button' onClick={onClick} aria-label={direction === 'left' ? 'prev' : 'next'} className={classNames('cursor-pointer rounded-md border border-border-gray-medium bg-surface-scrim-white text-text-black')} data-sentry-component="Arrow" data-sentry-source-file="arrow.tsx">
            {direction === 'left' ? <div className='flex h-8 w-8 items-center justify-center lg:h-[40px] lg:w-[40px]'>
                    <IconArrowSquareLeft className='h-7 w-7' />
                </div> : <div className='flex h-8 w-8 items-center justify-center lg:h-[40px] lg:w-[40px]'>
                    <IconArrowRight2 className='h-7 w-7' />
                </div>}
        </span>;
}